module.exports = __webpack_public_path__ + "static/media/riviera-mobile-popup.a793bf76.webp";